var _rect, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.89567,
    y: 8.81254,
    width: 33.2917,
    height: 21.5417,
    rx: 4.89583,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89551 14.6876H38.1872",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7915 25.4585H13.7082",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7915 21.5415H17.6248",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.3332,
    cy: 23.5002,
    r: 2.9375,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7915 30.3543V31.3335C9.7915 33.4966 11.5451 35.2501 13.7082 35.2501H37.2082C39.3713 35.2501 41.1248 33.4966 41.1248 31.3335V19.5835C41.1248 18.5019 40.2481 17.6251 39.1665 17.6251V17.6251",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditDebit);
export default __webpack_public_path__ + "static/media/credit_debit.5bcabb0946a6f7be412887e9b4887959.svg";
export { ForwardRef as ReactComponent };